export default __webpack_public_path__ + "static/media/Aura-Egg__68.e16e652f.png";